import { GridFilterModel, GridSortModel } from '@mui/x-data-grid';
import { action, makeAutoObservable } from 'mobx';
import moment from 'moment';
import { isMobileOnly } from 'react-device-detect';
import { ServiceAssignment } from '../domain/Publisher';
import { LocalStorageStore } from './LocalStorageStore';

export type HallMaintenanceSort = "standard" | "category" | "actual";

interface HomePage {
    tab: number;
}

interface PublisherPage {
    filter: GridFilterModel;
    sort: GridSortModel;
    page: number;
    current: number;
    tab: number;
}

interface GroupReportPage {
    filter: ServiceAssignment | string;
    page: number;
    date: Date;
}

interface HallMaintenancePageState {
    sort: HallMaintenanceSort;
}

interface SideBarMenu {
    schedule: boolean;
    congregation: boolean;
    reports: boolean;
    territories: boolean;
    carts: boolean;
    extra: boolean;
}

export class PanelStore {
    LocalStorageStore: LocalStorageStore;

    sideBarCollapsed = isMobileOnly;
    homePage = { tab: 0 } as HomePage;
    sideBarMenu = {
        schedule: false,
        congregation: false,
        reports: false,
        territories: false,
        carts: false,
        extra: false
    } as SideBarMenu;
    publishersPage = { tab: 0 } as PublisherPage;
    groupReportPage = {
        filter: "All",
        page: 0,
        date: moment().subtract(1, "month").toDate()
    } as GroupReportPage;
    hallMaintenancePage = {
        sort: "standard"
    } as HallMaintenancePageState;

    constructor(localStorageStore: LocalStorageStore) {
        this.LocalStorageStore = localStorageStore;
        makeAutoObservable(this);
        this.homePage.tab = this.LocalStorageStore.getHomePageTab();
    }

    setHomePageTab(tab: number) {
        this.homePage.tab = tab;
    }

    setCollapsed(collapsed: boolean) {
        this.sideBarCollapsed = collapsed;
    }

    setPublishersPageTab = (tab: number) => {
        this.publishersPage.tab = tab;
    }

    setPublishersPagePage = (page: number) => {
        this.publishersPage.page = page;
    }

    setPublishersPageFilter = (filter: GridFilterModel) => {
        this.publishersPage.filter = filter;
    }

    setPublishersPageSort = (sort: GridSortModel) => {
        this.publishersPage.sort = sort;
    }

    setPublishersPageCurrent = (id: number) => {
        this.publishersPage.current = id;
    }

    setGroupReportPageFilter = (filter: string) => {
        this.groupReportPage.filter = filter;
    }

    setGroupReportPagePage = (page: number) => {
        this.groupReportPage.page = page;
    }

    setGroupReportPageDate = (date: Date) => {
        this.groupReportPage.date = date;
    }

    setHallMaintenanceSort = (sort: HallMaintenanceSort) => {
        this.hallMaintenancePage.sort = sort;
    }

    setSideBarMenuOpen = (name: string, open: boolean) => {
        (this.sideBarMenu as any)[name] = open;
    }
}